import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("*");

export const Route = createFileRoute("/$")({
  head: () => ({
    meta: [
      { title: "Page not found — LevelLoad" },
      { name: "description", content: "Page not found — LevelLoad transport planning." },
      { property: "og:title", content: "Page not found — LevelLoad" },
      { property: "og:description", content: "Page not found — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
